export const BOOKING = '[BOOKING]'
export const GET_BOOKINGS = `${BOOKING} GET_BOOKINGS`
export const SET_BOOKINGS = `${BOOKING} SET_BOOKINGS`
